export const exampleCourseLog = [{
  "semester": "10710",
  "no": "CS  390200",
  "name": "系統整合實作二",
  "credit": "1",
  "isPassed": "成績未到"
}, {
  "semester": "10710",
  "no": "CS  546400",
  "name": "高科技創業與營運",
  "credit": "3",
  "isPassed": "成績未到"
}, {
  "semester": "10710",
  "no": "KLST630300",
  "name": "學習環境設計",
  "credit": "3",
  "isPassed": "成績未到"
}, {
  "semester": "10710",
  "no": "PE  205047",
  "name": "籃球",
  "credit": "0",
  "isPassed": "成績未到"
}, {
  "semester": "10620",
  "no": "CS  390100",
  "name": "系統整合實作一",
  "credit": "1",
  "isPassed": "及格"
}, {
  "semester": "10620",
  "no": "CS  446102",
  "name": "軟體工程",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10620",
  "no": "CS  471000",
  "name": "資料庫系統概論",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10620",
  "no": "GE  133500",
  "name": "互動設計概論",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10620",
  "no": "IPTH200200",
  "name": "產業長期實習B",
  "credit": "6",
  "isPassed": "及格"
}, {
  "semester": "10620",
  "no": "PE  206063",
  "name": "籃球進階",
  "credit": "0",
  "isPassed": "及格"
}, {
  "semester": "10620",
  "no": "ZZ  000000",
  "name": "操行",
  "credit": "0",
  "isPassed": "及格"
}, {
  "semester": "10520",
  "no": "CS  241002",
  "name": "軟體設計與實驗",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10520",
  "no": "CS  333201",
  "name": "機率",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10520",
  "no": "CS  410001",
  "name": "計算機結構",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10520",
  "no": "CS  423500",
  "name": "物聯網概論",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10520",
  "no": "GEC 150102",
  "name": "科學革命",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10520",
  "no": "TM  200202",
  "name": "管理學",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10520",
  "no": "ZZ  000000",
  "name": "操行",
  "credit": "0",
  "isPassed": "及格"
}, {
  "semester": "10510",
  "no": "CS  210402",
  "name": "硬體設計與實驗",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10510",
  "no": "CS  233401",
  "name": "線性代數",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10510",
  "no": "CS  235101",
  "name": "資料結構",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10510",
  "no": "CS  321201",
  "name": "計算機網路概論",
  "credit": "3",
  "isPassed": "二退"
}, {
  "semester": "10510",
  "no": "CS  333402",
  "name": "工程數學",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10510",
  "no": "GE  150600",
  "name": "表演藝術賞析",
  "credit": "2",
  "isPassed": "及格"
}, {
  "semester": "10510",
  "no": "LANG103024",
  "name": "英文三--閱讀",
  "credit": "2",
  "isPassed": "及格"
}, {
  "semester": "10510",
  "no": "PE  205087",
  "name": "籃球初學",
  "credit": "0",
  "isPassed": "及格"
}, {
  "semester": "10510",
  "no": "ZZ  000000",
  "name": "操行",
  "credit": "0",
  "isPassed": "及格"
}, {
  "semester": "10420",
  "no": "CS  135601",
  "name": "計算機程式設計二",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10420",
  "no": "CS  210202",
  "name": "數位邏輯設計",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10420",
  "no": "ILS 520800",
  "name": "使用者體驗設計",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10420",
  "no": "LANG102022",
  "name": "英文二",
  "credit": "2",
  "isPassed": "及格"
}, {
  "semester": "10420",
  "no": "MATH104005",
  "name": "微積分二",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10420",
  "no": "PE  112008",
  "name": "太極拳",
  "credit": "0",
  "isPassed": "及格"
}, {
  "semester": "10420",
  "no": "PHYS113407",
  "name": "普通物理Ｂ二",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10420",
  "no": "ZY  100217",
  "name": "服務學習--勞作服務",
  "credit": "0",
  "isPassed": "及格"
}, {
  "semester": "10420",
  "no": "ZZ  000000",
  "name": "操行",
  "credit": "0",
  "isPassed": "及格"
}, {
  "semester": "10410",
  "no": "CL  101014",
  "name": "大學中文",
  "credit": "2",
  "isPassed": "及格"
}, {
  "semester": "10410",
  "no": "CS  135502",
  "name": "計算機程式設計一",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10410",
  "no": "CS  135701",
  "name": "資訊系統及應用導論",
  "credit": "2",
  "isPassed": "及格"
}, {
  "semester": "10410",
  "no": "CS  233601",
  "name": "離散數學",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10410",
  "no": "GE  140500",
  "name": "產業創新與生涯探索",
  "credit": "2",
  "isPassed": "及格"
}, {
  "semester": "10410",
  "no": "GEC 110201",
  "name": "批判思考（通識）",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10410",
  "no": "LANG101022",
  "name": "英文一",
  "credit": "2",
  "isPassed": "及格"
}, {
  "semester": "10410",
  "no": "MATH103005",
  "name": "微積分一",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10410",
  "no": "PE  111027",
  "name": "大一體育",
  "credit": "0",
  "isPassed": "及格"
}, {
  "semester": "10410",
  "no": "PHYS113304",
  "name": "普通物理Ｂ一",
  "credit": "3",
  "isPassed": "及格"
}, {
  "semester": "10410",
  "no": "ZY  100217",
  "name": "服務學習--勞作服務",
  "credit": "0",
  "isPassed": "及格"
}, {
  "semester": "10410",
  "no": "ZZ  000000",
  "name": "操行",
  "credit": "0",
  "isPassed": "及格"
}].map(v => ({
  ...v,
  grade: v.isPassed === '及格' ? 'A' : v.isPassed,
}));